import { ChevronDownIcon } from "@chakra-ui/icons";
import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export function SidebarMenuItem({ href, icon, text, links = undefined }: any) {

  const [selected, setSelected] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { asPath } = useRouter()

  useEffect(() => {
    if (href) {
      const dashBoardSelected = href === '/' && asPath === '/';
      setSelected(dashBoardSelected || (href !== '/' && asPath.startsWith(href)));
    }

    if (links) {
      setExpanded(links.some((link) => asPath.startsWith(link.href)));
    }

  }, [asPath, href, links]);

  if (!links) {
    return (
      <Link href={href} passHref>
        <a>
          <Flex
            gap="5px"
            alignItems="center"
            padding="10px 20px"
            borderRadius="50px"
            transition="background 0.25s"
            background={selected ? 'red.400' : 'unset'}
            color={selected ? 'white' : 'red.400'}
            sx={{
              p: {
                color: selected ? 'white' : 'gray.600'
              }
            }}
            _hover={{
              background: 'black',
              color: 'white',
              p: {
                color: 'white !important'
              }
            }}
          >
            <Icon as={icon}
              fontSize={20}
              mr="2"
              transition="color 0.25s"
            />
            <Text transition="color 0.25s" color="gray.600">{text}</Text>
          </Flex>
        </a>
      </Link>
    )
  }

  if (links) {
    return (
      <Box>
        <Flex
          onClick={() => setExpanded(!expanded)}
          gap="5px"
          cursor="pointer"
          alignItems="center"
          padding="10px 20px"
          borderRadius="50px"
          transition="background 0.25s"
          background={selected ? 'red.400' : 'unset'}
          color={selected ? 'white' : 'red.400'}
          sx={{
            p: {
              color: selected ? 'white' : 'gray.600'
            }
          }}
          _hover={{
            background: 'black',
            color: 'white',
            p: {
              color: 'white !important'
            }
          }}
        >
          <Icon as={icon}
            fontSize={20}
            mr="2"
            transition="color 0.25s"
          />
          <Text transition="color 0.25s">{text}</Text>
          <Icon as={ChevronDownIcon}
            fontSize={20}
            ml="auto"
            transition="color 0.25s, transform 0.25s"
            transform={expanded ? "rotate(-180deg)" : ""}
          />
        </Flex>
        {expanded &&
          <Flex flexDirection="column" gap="10px" borderLeft="1px solid #CECECE" margin="10px 20px 0 20px" padding="10px 20px" >
            {links.map((link) => {
              return (
                <Link key={link.href} href={link.href}>
                  <a>
                    <Text color={asPath.includes(link.href) ? 'red.400' : 'unset'} _hover={{ color: 'red.400' }}>{link.text}</Text>
                  </a>
                </Link>
              )
            })}
          </Flex>
        }
      </Box>
    )
  }

  return (<></>);
}